import {
	ADD_BREATH_COUNT,
	ADD_GRATITUDE,
	ADD_PLACEHOLDER_THOUGHT,
	ADD_THOUGHT_SUCCESS,
	CREATE_SAGE_THOUGHT,
	FETCH_SENTIMENT_SCORE,
	FETCH_THOUGHT_NOUNS,
	FETCH_USER,
	GET_MONTHLY_GOLDEN_HOUR_STATS,
	GET_THOUGHT_COUNTS,
	GET_THOUGHT_NOUNS,
	GET_WEEKLY_GOLDEN_HOUR_STATS,
	MODIFY_TIMER_DURATION,
	REMOVE_THOUGHT,
	REMOVE_THOUGHT_EMOTIONS,
	SELECT_THOUGHT_EMOTIONS,
	SET_AUTHENTICATED,
	SET_AUTHORIZED,
	SET_AUTHORIZED_STATE,
	SET_BREATH_COUNT,
	SET_CURRENT_MONTH_THOUGHTS,
	SET_GRATITUDES,
	SET_PIN_TOKEN,
	SET_SAGE_THOUGHTS,
	SET_SESSION_TOKEN,
	UPDATE_SAGE_THOUGHT
} from './middleware';
import {
	NounCount,
	SageThought,
	SageThoughts,
	Thought,
	User,
	UUID
} from './schema';

export type PulseOfPlanetAction =
	| { type: typeof ADD_BREATH_COUNT; payload: { count: number } }
	| { type: typeof SET_BREATH_COUNT; payload: { count: number } }
	| { type: typeof ADD_GRATITUDE; payload: { text: string } }
	| { type: typeof SET_GRATITUDES; payload: { gratitudes: string[] } };

export type AuthAction =
	| { type: typeof SET_SESSION_TOKEN; payload: { token: string } }
	| { type: typeof SET_AUTHORIZED; payload: { isAuthorized: boolean } }
	| { type: typeof SET_AUTHORIZED_STATE; payload: { state: boolean } }
	| { type: typeof SET_AUTHENTICATED; payload: { isAuthenticated: boolean } }
	| { type: typeof SET_PIN_TOKEN; payload: { token: string } };

export type SageAction =
	| {
			type: typeof UPDATE_SAGE_THOUGHT;
			payload: { reframed_thought: string; thought_uuid: UUID };
	  }
	| {
			type: typeof CREATE_SAGE_THOUGHT;
			payload: { sage_thought: SageThought; thought_uuid: UUID };
	  }
	| {
			type: typeof SET_SAGE_THOUGHTS;
			payload: { sage_thoughts: SageThoughts };
	  };

export type ThoughtsAction =
	| {
			type: typeof SET_CURRENT_MONTH_THOUGHTS;
			payload: { thoughts: Thought[] };
	  }
	| {
			type: typeof ADD_PLACEHOLDER_THOUGHT;
			payload: { thought: Thought };
	  }
	| {
			type: typeof ADD_THOUGHT_SUCCESS;
			payload: { thought: Thought };
	  }
	| {
			type: typeof SELECT_THOUGHT_EMOTIONS;
			payload: {
				uuid: UUID;
				user_selected_emotions: string[];
				sentiment: string;
			};
	  }
	| {
			type: typeof REMOVE_THOUGHT_EMOTIONS;
			payload: { uuid: UUID };
	  }
	| { type: typeof REMOVE_THOUGHT; payload: { uuid: UUID } };

export type StatsAction =
	| {
			type: typeof FETCH_THOUGHT_NOUNS;
			payload: { nouns: NounCount };
	  }
	| {
			type: typeof FETCH_SENTIMENT_SCORE;
			payload: { score: number };
	  }
	| {
			type: typeof GET_WEEKLY_GOLDEN_HOUR_STATS;
			payload: { weeklyGoldenHour: number[][] };
	  }
	| {
			type: typeof GET_MONTHLY_GOLDEN_HOUR_STATS;
			payload: { monthlyGoldenHour: number[][] };
	  }
	| {
			type: typeof GET_THOUGHT_NOUNS;
			payload: {
				type: string;
				positiveThoughtNouns: NounCount;
				neutralThoughtNouns: NounCount;
				negativeThoughtNouns: NounCount;
			};
	  }
	| {
			type: typeof GET_THOUGHT_COUNTS;
			payload: {
				numPositiveThoughts: number;
				numNeutralThoughts: number;
				numNegativeThoughts: number;
			};
	  };

export type ConfigAction = {
	type: typeof MODIFY_TIMER_DURATION;
	payload: { duration: number };
};

export type UserAction = {
	type: typeof FETCH_USER;
	payload: { user: User };
};

export type RootActions =
	| AuthAction
	| ThoughtsAction
	| SageAction
	| StatsAction
	| ConfigAction
	| UserAction
	| PulseOfPlanetAction;

// Define action types for onboarding tasks
export const COMPLETE_ONBOARDING_TASK = 'COMPLETE_ONBOARDING_TASK';

export const RESET_ONBOARDING_TASK = 'RESET_ONBOARDING_TASK';

// Action creators
export const completeOnboardingTask = (task: string) => ({
	type: COMPLETE_ONBOARDING_TASK,
	payload: task
});

export const resetOnboardingTask = (task: string) => ({
	type: RESET_ONBOARDING_TASK,
	payload: task
});

